// Service Definitions client — per-offering setup context + patch.

import { manufacturingFetch } from "@/lib/manufacturingClient";
import type { ServiceDefinitionsContext, ServiceOffering } from "./types";

type OrgEnvelope = { ok: true; organization_id: string };

export function getServiceDefinitionsContext() {
  return manufacturingFetch<OrgEnvelope & ServiceDefinitionsContext>(
    "/api/service/definitions/context",
    { method: "GET" }
  );
}

export function patchServiceDefinition(payload: {
  offering_id: string;
  description?: string;
  quotable_from_sales?: boolean;
  subscriber_org_ids?: string[];
}) {
  return manufacturingFetch<
    OrgEnvelope & {
      offering: ServiceOffering;
      subscriber_org_ids: string[];
      product_types_synced?: boolean;
    }
  >("/api/service/definitions/patch", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}
